import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ProfileImageUpload from '../components/ProfileImageUpload';

// Styled components
const AppContainer = styled(Box)({
  display: 'flex',
  height: '100%',
  backgroundColor: '#f5f5f5'
});

const Sidebar = styled(Box)(({ theme }) => ({
  width: '150px',
  backgroundColor: 'white',
  borderRight: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2, 0),
}));

const MenuItemContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(1.5),
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const MenuItemText = styled(Typography)({
  fontSize: '0.85rem',
  color: '#666',
});

const MainContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(0),
  backgroundColor: '#f5f5f5',
  overflow: 'auto',
  height: '100vh',
}));

const Header = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  color: '#334155',
  padding: theme.spacing(1, 2),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
}));

const ContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const Stats: React.FC = () => {
  const { currentUser, userName } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigate = (path: string) => {
    console.log(`Navigerer til: ${path}`); // Debugging log
    if (path === 'Race') {
      navigate('/race');
    } else if (path === 'Calls') {
      navigate('/calls');
    } else if (path === 'Dashboard') {
      navigate('/agent-dashboard');
    } else if (path === 'Stats') {
      navigate('/stats');
    } else if (path === 'Training') {
      navigate('/training');
    } else {
      // Disse sider er endnu ikke implementeret
      console.log(`Side '${path}' er ikke implementeret endnu`);
    }
  };

  return (
    <AppContainer>
      {/* Sidebar / Menu */}
      <Sidebar>
        <Box sx={{ padding: '10px', marginBottom: 2 }}>
          <ProfileImageUpload />
        </Box>
        
        <MenuItemContainer onClick={() => handleNavigate('Dashboard')} sx={{ marginTop: 1 }}>
          <MenuItemText>{t('common.dashboard')}</MenuItemText>
        </MenuItemContainer>
        
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          padding: '12px', 
          cursor: 'default', 
          opacity: 0.7 
        }}>
          <MenuItemText>Development</MenuItemText>
        </Box>
        
        <MenuItemContainer onClick={() => handleNavigate('Stats')} sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
          <MenuItemText>Stats</MenuItemText>
        </MenuItemContainer>
        
        <MenuItemContainer onClick={() => handleNavigate('Calls')}>
          <MenuItemText>Calls</MenuItemText>
        </MenuItemContainer>
        
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          padding: '12px', 
          cursor: 'default', 
          opacity: 0.7 
        }}>
          <MenuItemText>Team</MenuItemText>
        </Box>
        
        <MenuItemContainer onClick={() => handleNavigate('Race')}>
          <MenuItemText>Race</MenuItemText>
        </MenuItemContainer>
        
        <MenuItemContainer onClick={() => handleNavigate('Training')}>
          <MenuItemText>{t('common.training')}</MenuItemText>
        </MenuItemContainer>
        
        <Divider sx={{ my: 1 }} />
        
        <MenuItemContainer onClick={() => handleNavigate('Help')}>
          <MenuItemText>Help</MenuItemText>
        </MenuItemContainer>
        
        <MenuItemContainer onClick={() => handleNavigate('Contact')}>
          <MenuItemText>Contact</MenuItemText>
        </MenuItemContainer>
      </Sidebar>
      
      {/* Main Content */}
      <MainContent>
        {/* Header */}
        <Header>
          <Typography variant="h6">{userName || "Voice Victor"}</Typography>
          <Typography variant="subtitle1">Stats</Typography>
        </Header>
        
        {/* Content */}
        <ContentBox>
          {/* Tom side for nu */}
        </ContentBox>
      </MainContent>
    </AppContainer>
  );
};

export default Stats; 